import { render } from "./bank-settings-grid-modal.vue?vue&type=template&id=c0ccabee"
import script from "./bank-settings-grid-modal.vue?vue&type=script&lang=js"
export * from "./bank-settings-grid-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__